import { filterOptions } from '@/utils/query-base'

const be = filterOptions(['EQ'])
const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'customer': {
    title: '商家编码',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ClientSelect',
      title: '商家编码'
    }
  },
  'cust_name': {
    title: '商家名称',
    type: 'input',
    equation: cusname,
    width: 200
  },
  'use_qty': {
    title: '使用数量(件)',
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'sal_center': {
    describe: true, // 描述 _text 添加属性
    title: '营销单元', // 字段名称
    type: 'select', // 输入类型 下拉
    equation: all, // 条件
    dictionary: 'sale' // 字典 （营销单元(sale)， 基地(base)，省(region)，市(city)，区(street)）
  },
  'center_dun': {
    title: '公司分配量(吨)',
    width: 150,
    xlsxFmt: {
      t: 'n',
      z: '0.00000000'
    }
  },
  'center_qty': {
    title: '公司分配量(件)',
    width: 150,
    xlsxFmt: {
      t: 'n',
      z: '0.000'
    }
  },
  'gjahr': {
    title: '年度',
    type: 'year',
    equation: cusname
  },
  'wlybrand': {
    describe: true,
    title: '存货分类',
    type: 'select',
    equation: all,
    dictionary: 'A0019',
    width: 180
  },
  'plan_type': {
    describe: true,
    title: '计划类型',
    type: 'select',
    equation: cusname,
    dictionary: 'A0002',
    width: 180
  },
  'region': {
    describe: true,
    title: '省份',
    type: 'select',
    equation: be,
    dictionary: 'region'
  },
  'city': {
    describe: true,
    title: '城市',
    type: 'select',
    equation: city,
    dictionary: 'city'
  }

}



// WEBPACK FOOTER //
// ./src/views/report-forms-manage/config/centerSumUseDetailReportForms.js